export const environment = {
  production: true,
  buildId: '2770994281818921',
  configFile: 'config.json',
};
